// extracted by mini-css-extract-plugin
export default {"CardHeader":"CardHeaderWidget_CardHeader__WUCnT","titleStyle":"CardHeaderWidget_titleStyle__5VYZh"};